<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import MarketingDataService from "@/services/MarketingDataService";
import DatePicker  from "vue2-datepicker";
import 'vue2-datepicker/index.css';
import isEmpty from "is-empty";

const ads = {};
const marketing = {};
const organic = {};
const adsData1 = {};
const adsData2 = {};

export default {
  page: {
    localePicker: () => import(`vue2-datepicker/locale/${this.$i18n.locale}`),
    title: "Installs",
    meta: [
      {
        name: "description",
        content: appConfig.description
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
  },
  methods: {
    _isEmpty(val) {
      return isEmpty(val);
    },

    getRequestParams(page, pageSize) {
      let params = {};

      if (page) {
        params["page"] = page - 1;
      }

      if (pageSize) {
        params["size"] = pageSize;
      }

      return params;
    },

    handleDisplayChange() {
      this.page = 1;

      const params = this.getRequestParams(
          this.page,
          this.pageSizes.selected,
      );

      MarketingDataService.getInstalls(params)
          .then(response => {
            window.console.log("getInstalls response:", response.data);
            const { items, totalItems } = response.data;
            this.installs = items;
            this.count = totalItems;
          })
          .catch(error => {
            window.console.log(error);
            this.$toast.error(this.$t("marketing.installs.errorNoResult"));
          });
    },

    handlePageChange(value) {
      this.page = value;
      this.processFilters();
    },

    handleDateChange() {
      let now = new this.$moment();
      switch(this.filters.dates.selected) {
        case "always":
          this.filters.fromDate = new this.$moment('2021-01-01').format('YYYY-MM-DD');
          this.filters.toDate = now.format('YYYY-MM-DD');
          break;
        case "today":
          this.filters.fromDate = now.format('YYYY-MM-DD');
          this.filters.toDate = now.format('YYYY-MM-DD');
          break;
        case "yesterday":
          this.filters.toDate = now.subtract(1, 'day').format('YYYY-MM-DD');
          this.filters.fromDate = this.filters.toDate;
          break;
        case "week":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filters.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filters.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filters.fromDate = null;
          this.filters.toDate = null;
          break;
      }
    },

    getFilters() {
      MarketingDataService.getInstallsFilters()
          .then(response => {
            response.data.filters.sdks.forEach(sdk => {
              this.filters.sdks.options.push(sdk);
            });
            /*response.data.filters.ads.forEach(ad => {
              this.filters.ads.options.push(ad);
            });*/
            response.data.filters.devices.forEach(device => {
              this.filters.devices.options.push(device);
            });
          })
          .catch(error => {
            window.console.log(error);
            this.$toast.error(this.$t("marketing.installs.getFilters"));
          });

      MarketingDataService.getAdsNonOrganicFilters()
          .then(response => {
            response.data.filters.ads.forEach(ad => {
              this.filters.ads.options.push(ad);
            });
          })
          .catch(error => {
            window.console.log(error);
            this.$toast.error(this.$t("marketing.getAdsNonOrganicFilters"));
          });
    },

    trunc(value) {
      if (!isEmpty(value)) {
        if (value.length > 70)
          return value.substring(0, 70) + "…";
        else
          return value;
      }
      else {
        return "";
      }
    },

    processFilters() {
      if (!this.isLoading)
        this.isLoading = true;

      const params = this.getRequestParams(
          this.page,
          this.pageSizes.selected,
      );

      if (this.filters.dates.selected === 'custom' && this.filters.dates.dateRange !== null) {
        this.filters.fromDate = this.$moment(this.filters.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filters.toDate = this.$moment(this.filters.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filters.fromDate === null)
        this.handleDateChange();

      if (this.filters.toDate !== null)
        params['toDate'] = this.filters.toDate;

      if (this.filters.fromDate !== null)
        params['fromDate'] = this.filters.fromDate;

      params['sdks'] = this.filters.sdks.selected;
      params['devices'] = this.filters.devices.selected;
      params['organic'] = this.filters.organic.selected;
      if (this.filters.adsData3.selected !== 'all') {
        params['ads'] = this.filters.adsData3.selected;
      }
      else if (this.filters.adsData2.selected !== 'all') {
        params['ads'] = this.filters.adsData2.selected;
      }
      else if (this.filters.adsData1.selected !== 'all') {
        params['ads'] = this.filters.adsData1.selected;
      }
      else {
        params['ads'] = this.filters.ads.selected;
      }

      MarketingDataService.getInstalls(params)
          .then(response => {
            window.console.log("getInstalls response:", response.data);
            const { items, totalItems } = response.data;
            this.installs = items;
            this.count = totalItems;
          })
          .catch(error => {
            window.console.log(error);
            this.$toast.error(this.$t("marketing.installs.errorNoResult"));
          });

      MarketingDataService.getInstallsStats(params)
          .then(response => {
            window.console.log("getInstallsStats response:", response.data);
            this.stats.ads.series = response.data.ads.series;
            this.stats.ads.chartOptions = {...this.stats.ads.chartOptions, ...{
                labels: response.data.ads.labels
              }};

            this.stats.sdks.series = response.data.sdks.series;
            this.stats.sdks.chartOptions = {...this.stats.sdks.chartOptions, ...{
                labels: response.data.sdks.labels
              }};

            this.stats.devices.series = response.data.devices.series;
            this.stats.devices.chartOptions = {...this.stats.devices.chartOptions, ...{
                labels: response.data.devices.labels
              }};

            this.$refs.installsTypeGraph.updateSeries([{
              name: "Installs",
              type: 'line',
              data: response.data.typeGraph.raw
            },{
              name: "Registered",
              type: "column",
              data: response.data.typeGraph.register
            }, {
              name: "Logged",
              type: "column",
              data: response.data.typeGraph.login
            }]);

            this.total.installs = response.data.total.installs;
            this.total.registered = response.data.total.registered;
            this.total.logged = response.data.total.logged;
            this.total.loginMen = response.data.total.loginMen;
            this.total.registerMen = response.data.total.registerMen;
            this.total.ageMen = response.data.total.ageMen;
            this.total.loginWomen = response.data.total.loginWomen;
            this.total.registerWomen = response.data.total.registerWomen;
            this.total.ageWomen = response.data.total.ageWomen;

            this.isLoading = false;
          })
          .catch(error => {
            window.console.log(error);
            this.isLoading = false;
            this.$toast.error(this.$t("marketing.installs.errorNoResult"));
          })
    },

    getGenderImg(sex) {
      return require('@/assets/images/'+(sex === 1?'man':'woman')+'.png')
    },
  },
  watch: {
    "filters.organic.selected": function (newVal, oldVal) {
      if (oldVal === newVal)
        return;

      if (newVal === "organic") {
        this.filters.ads.selected = 'all';
        this.filters.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (isEmpty(organic)) {
          MarketingDataService.getAdsOrganicFilters()
              .then(response => {
                response.data.filters.ads.forEach(ad => {
                  this.filters.ads.options.push(ad);
                });

                organic.ads = response.data.filters.ads;
              })
              .catch(error => {
                window.console.log(error);
                this.$toast.error(this.$t("marketing.getAdsOrganicFilters"));
              });
        }
        else {
          organic.ads.forEach(ad => {
            this.filters.ads.options.push(ad);
          });
        }
      }
      else if (['marketing', 'all'].includes(newVal) && oldVal === "organic") {
        this.filters.ads.selected = 'all';
        this.filters.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (!isEmpty(marketing)) {
          marketing.ads.forEach(ad => {
            this.filters.ads.options.push(ad);
          });
        }
      }
    },
    "filters.ads.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

        this.filters.adsData1.selected = 'all';
        this.filters.adsData2.selected = 'all';
        this.filters.adsData3.selected = 'all';
        this.filters.adsData1.options = [{
          value: 'all', text: 'All Data1'
        }];
        this.filters.adsData2.options = [{
          value: 'all', text: 'All Data2'
        }];
        this.filters.adsData3.options = [{
          value: 'all', text: 'All Data3'
        }];

        if (isEmpty(ads[newVal])) {
          MarketingDataService.getAdsNonOrganicData1Filters(newVal)
              .then(response => {
                response.data.filters.ads.forEach(ad => {
                  this.filters.adsData1.options.push(ad);
                });

                ads[newVal] = response.data.filters.ads;
              })
              .catch(error => {
                window.console.log(error);
                this.$toast.error(this.$t("marketing.getAdsNonOrganicData1Filters"));
              });
        }
        else {
          ads[newVal].forEach(ad => {
            this.filters.adsData1.options.push(ad);
          });
        }
    },
    "filters.adsData1.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

        this.filters.adsData2.selected = 'all';
        this.filters.adsData3.selected = 'all';
        this.filters.adsData2.options = [{
          value: 'all', text: 'All Data2'
        }];
        this.filters.adsData3.options = [{
          value: 'all', text: 'All Data3'
        }];

        if (isEmpty(adsData1[newVal])) {
          MarketingDataService.getAdsNonOrganicData2Filters(newVal)
              .then(response => {
                marketing.ads = response.data.filters.ads;
                response.data.filters.ads.forEach(ad => {
                  this.filters.adsData2.options.push(ad);
                });

                adsData1[newVal] = response.data.filters.ads;
              })
              .catch(error => {
                window.console.log(error);
                this.$toast.error(this.$t("marketing.getAdsNonOrganicData2Filters"));
              });
        }
        else {
          adsData1[newVal].forEach(ad => {
            this.filters.adsData2.options.push(ad);
          });
        }
    },
    "filters.adsData2.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

        this.filters.adsData3.selected = 'all';
        this.filters.adsData3.options = [{
          value: 'all', text: 'All Data3'
        }];

        if (isEmpty(adsData2[newVal])) {
          MarketingDataService.getAdsNonOrganicData3Filters(newVal)
              .then(response => {
                response.data.filters.ads.forEach(ad => {
                  this.filters.adsData3.options.push(ad);
                });

                adsData2[newVal] = response.data.filters.ads;
              })
              .catch(error => {
                window.console.log(error);
                this.$toast.error(this.$t("marketing.getAdsNonOrganicData3Filters"));
              });
        }
        else {
          adsData2[newVal].forEach(ad => {
            this.filters.adsData3.options.push(ad);
          });
        }
      }
  },

  data() {
    return {
      stats: {
        sdks: {
          series:[],
          chartOptions: {
            chart: {
              id: 'installs-sdk',
              type: 'donut',
            },
            labels: [],
            dataLabels: {
              enabled: true
            },
            legend: {
              position: 'left'
            },
            noData: {
              text: 'Loading...'
            }
          },
        },
        devices: {
          series:[],
          chartOptions: {
            chart: {
              id: 'installs-devices',
              type: 'donut',
            },
            dataLabels: {
              enabled: true
            },
            labels:[],
            noData: {
              text: 'Loading...'
            },
            legend: {
              position: 'left'
            },
          }
        },
        ads: {
          series:[],
          chartOptions: {
            chart: {
              id: 'installs-ads',
              type: 'donut',
            },
            labels: [],
            dataLabels: {
              enabled: true
            },

            legend: {
              position: 'left'
            },
            noData: {
              text: 'Loading...'
            }
          },
        },
        typeGraph: {
          series:[],
          chartOptions: {
            chart: {
              id: 'installs-types',
              type: 'line',
              height: 350,
              zoom: {
                autoScaleYaxis: true
              },

              toolbar: {
                show: true,
                offsetX: 0,
                offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: false,
                  reset: true
                }
              }
            },
            colors: ['#999999', '#34c38f', '#77B6EA'],
            dataLabels: {
              enabled: false
            },
            xaxis: {
              type: 'datetime',
              labels: {
                show: true,
                style: {
                  fontSize: 0
                },
                hideOverlappingLabels: true
              }
            },
            stroke: {
              curve: 'smooth',
              width: 2
            },
            noData: {
              text: 'Loading...'
            }
          },
        }
      },
      total: {
        installs: 0,
        registered: 0,
        loggedIn: 0,
        registerMen: 0,
        loginMen: 0,
        registerWomen: 0,
        loginWomen: 0,
        ageMen: 0,
        ageWomen: 0
      },
      installs: [],
      page: 1,
      count: 0,
      isLoading: true,
      title: this.$t("menuitems.marketing.installs"),
      pageSizes: {
        options: ['20', '50', '100'],
        selected: '20'
      },
      pane: {
        installSize: 0
      },
      filters: {
        fromDate: null,
        toDate: null,
        sdks: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All SDKs'
          }]
        },
        organic: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Source'},
            {value: 'organic', text: 'Only Organic'},
            {value: 'marketing', text: 'Only Marketing'}
          ]
        },
        ads: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Ads'
          }]
        },
        adsData1: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data1'
          }]
        },
        adsData2: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data2'
          }]
        },
        adsData3: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data3'
          }]
        },
        devices: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Devices'
          }]
        },
        dates: {
          dateRange: null,
          selected: 'today',
          options: [
              {value:'today', text:this.$t("dates.today")},
              {value:'yesterday', text:this.$t("dates.yesterday")},
              {value:'week', text:this.$t("dates.week")},
              {value:'curMonth', text:this.$t("dates.curMonth")},
              {value:'last30Day', text:this.$t("dates.last30Day")},
              {value:'lastMonth', text:this.$t("dates.lastMonth")},
              {value:'last3Month', text:this.$t("dates.last3Month")},
              {value:'curYear', text:this.$t("dates.curYear")},
              {value:'always', text:this.$t("dates.always")},
              {value:'custom', text:this.$t("dates.custom")}
          ]
        }
      }
    };
  },

  mounted() {
    this.getFilters();
    this.processFilters();
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div>
      <!-- Filters -->
      <div class="card">
        <div class="card-body row">
          <b-form inline class="row gy-2 gx-3 align-items-center" id="installsFiltersForm" @submit.stop.prevent>

            <!-- dates -->
            <div class="col-sm-auto d-flex">
              <b-form-select
                  id="installDatesFilter"
                  @change="handleDateChange"
                  v-model="filters.dates.selected"
                  class="form-select me-lg-1"
                  :options="filters.dates.options">
              </b-form-select>
              <date-picker
                  v-show="filters.dates.selected === 'custom'"
                  :lang="page.localePicker"
                  :placeholder="this.$t('choose_date_interval')"
                  type="date"
                  value-type="format"
                  show-week-number
                  v-model="filters.dates.dateRange"
                  class="me-lg-2"
                  range append-to-body ></date-picker>

            </div>

            <!-- Organic -->
            <div class="col-sm-auto">
              <b-form-select
                  id="installOrganicFilter"
                  v-model="filters.organic.selected"
                  class="form-select me-lg-1"
                  :options="filters.organic.options">
              </b-form-select>
            </div>

            <!-- Ads -->
            <div class="col-sm-auto">
              <b-form-select
                  id="installAdsFilter"
                  v-model="filters.ads.selected"
                  class="form-select me-lg-1"
                  :options="filters.ads.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filters.ads.selected !== 'all'">
              <b-form-select
                  id="installAdsData1Filter"
                  v-model="filters.adsData1.selected"
                  class="form-select me-lg-1"
                  :options="filters.adsData1.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filters.adsData1.selected !== 'all'">
              <b-form-select
                  id="installAdsData2Filter"
                  v-model="filters.adsData2.selected"
                  class="form-select me-lg-1"
                  :options="filters.adsData2.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto" v-show="filters.adsData2.selected !== 'all'">
              <b-form-select
                  id="installAdsData3Filter"
                  v-model="filters.adsData3.selected"
                  class="form-select me-lg-1"
                  :options="filters.adsData3.options">
              </b-form-select>
            </div>

            <!-- SDKs -->
            <div class="col-sm-auto">
              <b-form-select
                  id="installSdkFilter"
                  v-model="filters.sdks.selected"
                  class="form-select me-lg-1"
                  :options="filters.sdks.options">
              </b-form-select>
            </div>

            <!-- Devices -->
            <div class="col-sm-auto">
              <b-form-select
                  id="installDevicesFilter"
                  v-model="filters.devices.selected"
                  class="form-select me-lg-1"
                  :options="filters.devices.options">
              </b-form-select>
            </div>

            <div class="col-sm-auto">
              <b-button variant="primary" class="w-md" @click="processFilters">{{ $t("find") }}</b-button>
            </div>
          </b-form>
        </div>
      </div>

      <!-- Loader -->
      <div class="row d-flex justify-content-center">
        <vue-ellipse-progress
            v-show="isLoading"
            :loading="isLoading"
            :angle="-90"
            color="#50a5f1"
            emptyColor="#999"
            emptyColorFill="#f8f8fb"
            :size="100"
            :thickness="3"
            :emptyThickness="2"
            lineMode="out 2"
            animation="bounce 700 400"
            fontColor="#666"
            :half="false"
            class="mt-5 mb-5"
            fontSize="1rem">
        </vue-ellipse-progress>
      </div>

      <!-- Stats Plain -->
      <div class="row">
        <!-- Installs -->
        <div class="col-lg-3">
          <div class="card mini-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-3">
                  <p class="text-muted mb-2">App Installs</p>
                  <h5 class="mb-0">{{ total.installs }}</h5>
                </div>

                <div class="avatar-sm ms-auto">
                  <div
                      class="avatar-title bg-info rounded-circle white font-size-20"
                  >
                    <i class="bx bx-download"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Registered -->
        <div class="col-lg-3">
          <div class="card blog-stats-wid ">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-3">
                  <p class="text-muted mb-2">Account created</p>
                  <h5 class="mb-0">{{ total.registered }} <i class="fa fa-arrow-circle-right text-primary"></i>  <small class="text-muted">{{ total.registerMen }} men - {{ total.registerWomen }} women</small></h5>
                </div>

                <div class="avatar-sm ms-auto">
                  <div
                      class="avatar-title bg-success text-white rounded-circle font-size-20"
                  >
                    <i class="bx bxs-folder-plus"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Logged -->
        <div class="col-lg-3">
          <div class="card blog-stats-wid">
            <div class="card-body">
              <div class="d-flex flex-wrap">
                <div class="me-3">
                  <p class="text-muted mb-2">Logged only Installs</p>
                  <h5 class="mb-0">{{ total.logged }} <i class="fa fa-arrow-circle-right text-primary"></i>  <small class="text-muted">{{ total.loginMen }} men - {{ total.loginWomen }} women</small></h5>
                </div>

                <div class="avatar-sm ms-auto">
                  <div
                      class="avatar-title bg-pink rounded-circle text-white font-size-20"
                  >
                    <i class="bx bxs-right-arrow-square"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Gender -->
        <div class="col-lg-3">
          <div class="card blog-stats-wid">
            <div class="card-body row">
              <div class="col-10 row">
                <div class="col-6 text-center">
                  <p class="text-muted mb-2">Men</p>
                  <h5 class="mb-0">{{ total.ageMen }} y.o</h5>
                </div>
                <div class="col-6 text-center">
                  <p class="text-muted mb-2">Women</p>
                  <h5 class="mb-0">{{ total.ageWomen }} y.o</h5>
                </div>
              </div>
              <div class="col-2">
                <div class="avatar-sm ms-auto">
                  <div
                      class="avatar-title bg-light rounded-circle text-primary font-size-20"
                  >
                    <i class="bx bxs-user"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Charts -->
      <div class="row">
        <div class="col-12 col-lg-4">

          <div class="card">
            <div class="card-body" id="cardChartDevices">
              <h5 class="card-title">Devices</h5>
              <apexchart
                  ref="installsDevicesChart"
                  height="250"
                  type="donut"
                  dir="ltr"
                  :series="stats.devices.series"
                  :options="stats.devices.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>

        <div class="col-12 col-lg-4">

          <div class="card">
            <div class="card-body" id="cardChartSDK">
              <h5 class="card-title">SDK</h5>
              <apexchart
                  ref="installsSDKChart"
                  type="donut"
                  height="250"
                  dir="ltr"
                  :series="stats.sdks.series"
                  :options="stats.sdks.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>

        <div class="col-12 col-lg-4">

          <div class="card">
            <div class="card-body" id="cardChartAds">
              <h5 class="card-title">Ads</h5>
              <apexchart
                  ref="installsAdsChart"
                  type="donut"
                  height="250"
                  dir="ltr"
                  :series="stats.ads.series"
                  :options="stats.ads.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>

      </div>

      <!-- Charts 2 -->
      <div class="row">

        <div class="col-12">

          <div class="card">
            <div class="card-body" id="cardChartTypes">
              <h5 class="card-title">Installs Evolution</h5>
              <apexchart
                  ref="installsTypeGraph"
                  type="line"
                  dir="ltr"
                  height="350"
                  :series="stats.typeGraph.series"
                  :options="stats.typeGraph.chartOptions"
              ></apexchart>
            </div>
          </div>

        </div>

      </div>

      <!-- Top list tools -->
      <div class="row mb-3">
        <!-- Display settings -->
        <div class="col-lg-auto col-12">
          <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleDisplayChange">
            <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
          </b-select>
        </div>
        <!-- Pagination -->
        <div class="col-lg-auto col-12">
          <div class="m-1 pagination-rounded">
            <b-pagination
                v-model="page"
                :total-rows="count"
                :per-page="pageSizes.selected"
                first-number
                last-number
                @change="handlePageChange"
                aria-controls="installs-list"
            ></b-pagination>
            </div>
        </div>
      </div>

      <div class="row bg-white" v-if="!isLoading && installs.length > 0">
        <!-- Result list -->
        <div class="table-responsive">
          <table
              id="installs-list"
              class="table project-list-table table-nowrap table-centered table-borderless align-middle">
            <thead>
            <tr>
              <th scope="col">Install ID</th>
              <th scope="col">{{ $t("marketing.installedAt") }}</th>
              <th scope="col">{{ $t("marketing.campaign") }}</th>
              <th scope="col">{{ $t("marketing.app") }}</th>
              <th scope="col">{{ $t("marketing.device") }}</th>
              <th scope="col">{{ $t("marketing.user") }}</th>
              <th scope="col">{{ $t("action") }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="install in installs" :key="install.documentId">
              <td :class="{
              'install-male': install.userSex === 1,
              'install-female': install.userSex === 2,
              'install-default': install.userSex === 0,
              }">
                <small>{{ install.documentId }}</small><br>
                <span class="badge ms-1 bg-dark p-1" v-if="!_isEmpty(install.registerAt)">register</span>
                <span class="badge ms-1 bg-secondary p-1" v-if="!_isEmpty(install.loggedAt)">login</span>
              </td>
              <td>
                <i class="bx bx-calendar-event"></i> {{ new Date(install.installedAt) | moment('DD MMM YYYY HH:mm') }}
              </td>
              <td>
                <b class="text-success">{{ install.organic === 1 ? "Organic" : "Marketing"}}</b><br>
                <b class="text-primary">{{ install.adSource }}</b><br>
                <b>{{ install.adCampaign || "-"}}</b><span v-show="!_isEmpty(install.adChannel)"><i> ({{ install.adChannel }})</i></span>
                <span class="text-muted" v-show="!_isEmpty(install.adData1)"><br>{{ trunc(install.adData1) }}</span>
                <span class="text-muted" v-show="!_isEmpty(install.adData2)"><br>{{ trunc(install.adData2) }}</span>
                <span class="text-muted" v-show="!_isEmpty(install.adData3)"><br>{{ trunc(install.adData3) }}</span>
              </td>
              <td>
                <b>{{ install.appVersionName }}</b>
              </td>
              <td>
                {{ install.deviceBrand }}<br>
                SDK <b>{{ install.sdkVersion }}</b>
              </td>
              <td>
                <div v-show="install.userId !== '-'">
                  <small>{{ install.userId }}</small><br>
                  Age {{ install.userAge }}

                </div>
              </td>
              <td>
                <a href="javascript:void(0);" @click="$bvModal.show('mod_'+install.documentId)"><i class="mdi mdi-dots-horizontal font-size-18"></i></a>
              </td>
              <b-modal :id="'mod_' + install.documentId" title="Install Details" centered hide-footer >
                <p class="mb-2">
                  <span class="badge me-2 bg-warning p-1">{{ install.appVersionName }}</span> <span class="text-muted">#{{ install.documentId }}</span>
                </p>
                <p class="mb-1">
                  <i class="bx bx-calendar-event"></i> Installed At:
                  <span class="text-info">{{ new Date(install.installedAt) | moment('DD MMM YYYY HH:mm') }}</span>
                </p>
                <p class="mb-2">
                  <i class="bx bx-calendar-event"></i> Clicked At:
                  <span class="text-muted">{{ new Date(install.clickedAt) | moment('DD MMM YYYY HH:mm') }}</span>
                </p>
                <div class="mt-3 card bg-light" v-show="install.userId !== ''">
                  <div class="card-body p-2">
                    <p class="mb-2">
                      <span class="badge me-2 bg-dark p-1" v-if="install.registerAt !== ''">register</span>
                      <span class="badge me-2 bg-secondary p-1" v-if="install.loggedAt !== ''">login</span>
                      <span class="text-muted">#{{ install.userId }}</span>
                    </p>
                    <p class="mb-0"><img :src="getGenderImg(install.userSex)" alt=""> {{ install.userAge }} y.o</p>
                  </div>
                </div>
                <div class="table-responsive mt-4 mb-0">
                  <h5 class="text-truncate font-size-14 mb-0">
                    <i class="bx bx-mobile"></i> Device
                  </h5>
                  <table class="table table-centered table-nowrap">
                    <thead>
                    <tr>
                      <th scope="col" style="width:150px !important;"></th>
                      <th scope="col"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td><p class="text-muted mb-0">Brand:</p></td>
                      <td><p class="text-muted mb-0"><span class="text-info">{{ install.deviceBrand }}</span></p></td>
                    </tr>
                    <tr>
                      <td><p class="text-muted mb-0">Manufacturer:</p></td>
                      <td><p class="text-muted mb-0">{{ install.deviceManufacturer }}</p></td>
                    </tr>
                    <tr>
                      <td><p class="text-muted mb-0">Model:</p></td>
                      <td><p class="text-muted mb-0">{{ install.deviceModel }}</p></td>
                    </tr>
                    <tr>
                      <td><p class="text-muted mb-0">SDK:</p></td>
                      <td><p class="text-muted mb-0"><b>{{ install.sdkVersion }}</b></p></td>
                    </tr>
                    </tbody>
                  </table>

                  <h5 class="text-truncate font-size-14 mt-4 mb-0">
                    <i class="bx bx-stats"></i> Ad
                  </h5>
                  <table class="table table-centered table-nowrap">
                    <thead>
                    <tr>
                      <th scope="col" style="width:150px !important;"></th>
                      <th scope="col"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td><p class="text-muted mb-0">Source:</p></td>
                      <td><p class="text-muted mb-0"><span class="text-info">{{ install.adSource }}</span></p></td>
                    </tr>
                    <tr>
                      <td><p class="text-muted mb-0">Campaign:</p></td>
                      <td><p class="text-muted mb-0">{{ install.adCampaign }}</p></td>
                    </tr>
                    <tr>
                      <td><p class="text-muted mb-0">Medium:</p></td>
                      <td><p class="text-muted mb-0">{{ install.adMedium }}</p></td>
                    </tr>
                    <tr>
                      <td><p class="text-muted mb-0">Content:</p></td>
                      <td><p class="text-muted mb-0">{{ install.adContent }}</p></td>
                    </tr>
                    </tbody>
                  </table>
               </div>
              </b-modal>
            </tr>
            </tbody>
          </table>
        </div>
        <!-- END Result list -->
      </div>

      <!-- bottom list tools -->
      <div class="row mb-3">
        <!-- Display settings -->
        <div class="col-lg-auto col-12">
          <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleDisplayChange">
            <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
          </b-select>
        </div>
        <!-- Pagination -->
        <div class="col-lg-auto col-12">
          <div class="m-1 pagination-rounded">
            <b-pagination
                v-model="page"
                :total-rows="count"
                :per-page="pageSizes.selected"
                first-number
                last-number
                @change="handlePageChange"
                aria-controls="installs-list"
            ></b-pagination>
          </div>
        </div>
      </div>

    </div>
  </Layout>
</template>

<style>
  .install-default {
    border-left: solid 10px #ccc;
  }

  .install-male {
    border-left: solid 10px #77B6EA;
  }

  .install-female {
    border-left: solid 10px #f06292;
  }

  .cursor-pointer {
    cursor:pointer;
  }

</style>
